import { useEffect, useRef } from 'react'
import Select, { components, OptionProps, Props as SelectProps } from 'react-select'
import styles from './UISelect.module.css'

function CustomOption<T>(props: OptionProps<T>) {
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (props.isSelected && ref.current) {
      ref.current.scrollIntoView({ block: 'nearest' })
    }
  }, [props.isSelected])

  return (
    <components.Option
      {...props}
      innerRef={(element) => {
        ref.current = element
      }}
    />
  )
}

export function UISelect<T, Multi extends boolean>({ ...props }: SelectProps<T, Multi>) {
  return (
    <Select
      components={{
        IndicatorSeparator: () => null,
        Option: CustomOption,
      }}
      unstyled
      classNamePrefix="widgetSelect"
      className={styles.widgetSelect}
      isClearable
      menuShouldScrollIntoView={true}
      {...props}
    />
  )
}
